import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/mitr_itfdef",
    name: "mitr_itfdef",
    redirect: "/mitr_itfdef/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "mitr_itfdef_index",
        meta: {title: "监控中心",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/mitr/itfdef/index")
      }
    ]
  },
  {
    path: "/mitr_message",
    name: "mitr_message",
    redirect: "/mitr_message/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "mitr_message_index",
        meta: {title: "消息系统",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/mitr/message")
      }
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/mitr.js